import { useContext } from 'react';
import moneyFormat from '../functions/moneyFormat';
import decimalToPercent from '../functions/decimalToPercent'; 
import PageContext from './PageContext'; 
import { TableCell } from '@mui/material';

// pass row in props
const OverrideRow = ({ row, count, tableHeader,stickyEnabled }) => {
    // context from parent
    const {
        rebateInputTypeId, 
    } = useContext(PageContext);


    const getRowClassName = (columnOrder) =>{
        // Pass sticky row class if columnOrder is 0 i.e first column and stickyEnabled Prop is true
        return stickyEnabled && columnOrder===0 ? "table-cell-sticky-row": ""
    }

    return(
        <>
            {/* map logic over all columns in row object */}
            {tableHeader.map(el =>
                // logic to apply money format to correct rows
                el['columnname'] == 'cyclenetspend' || el['columnname'] == 'cyclenetinterchange' || el['columnname'] == 'cycleincentiveamount' ?
                    <> 
                        {row[el['columnname']] == null ?
                            <TableCell className={getRowClassName(el['columnorder'])} align='right'>None</TableCell>
                        :<TableCell className={getRowClassName(el['columnorder'])} align='right'>{moneyFormat(row[el['columnname']])}</TableCell>}
                    </>
                // convert to percent if rebateInputTypeId is 1
                : rebateInputTypeId == 1 && el['columnname'] == 'incentiverate' && row[el['columnname']] != null ? 
                    <TableCell className={getRowClassName(el['columnorder'])} align='right'>{decimalToPercent(row[el['columnname']])}</TableCell>
                // standard display for other cols
                : <> {row[el['columnname']] == null ?
                        <TableCell className={getRowClassName(el['columnorder'])}>None</TableCell>
                    :<TableCell className={getRowClassName(el['columnorder'])}>{row[el['columnname']]}</TableCell>}
                </>
            )}
        </>
    );
}   

export default OverrideRow;